import styled from 'styled-components';

const Logo = styled.img`
  width: 129px;
  padding: 15px 0;
  border-style: none;
`;

export default Logo;
